export default import.meta.ROLLDOWN_FILE_URL_SIhprirKpoi1x8GdHTYWvQ